import { MemoTag } from '../graphql.generated';

export const NotificationTagLabel = {
  [MemoTag.Kpi]: 'Alert',
  [MemoTag.BrokenNetworkIntegration]: 'Network Failure',
  [MemoTag.PayoutChange]: 'Payout Change',
};

export const NotificationTagColor = {
  [MemoTag.Kpi]: '#1890ff',
  [MemoTag.BrokenNetworkIntegration]: '#faad14',
  [MemoTag.PayoutChange]: '#722ed1',
};
